<template>
    <el-table
        v-loading="status == 'loading'"
        :data="datas"
        style="width: 100%"
        empty-text="沒有資料"
        class="accounting-summary-table accounting-summary-payment-table"
        :height="maxHeight"
        border
        @selection-change="$emit('selected', $event)"
        @row-click="onRowClick"
    >
        <el-table-column type="selection" width="42" fixed></el-table-column>
        <el-table-column label="財會檢核" align="left" width="80" fixed>
            <template slot-scope="scope">
                <AccountingStatusLabel :statusNum="scope.row.vocherStatus" />
            </template>
        </el-table-column>
        <el-table-column label="核准傳票" width="76" class-name="strong" align="center" fixed>
            <template slot-scope="scope">
                <div :class="{'blur-zero' : scope.row.approvedVocherQty === 0}">{{ scope.row.approvedVocherQty }}</div>
            </template>
        </el-table-column>
        <el-table-column label="待辦傳票" width="76" class-name="strong" align="center" fixed>
            <template slot-scope="scope">
                <div :class="{ 'blur-zero': scope.row.vocherQty - scope.row.approvedVocherQty === 0 }">{{ scope.row.vocherQty - scope.row.approvedVocherQty }}</div>
            </template>
        </el-table-column>
        <el-table-column prop="summary" label="借款名稱" width="180" class-name="strong" fixed>
            <template slot-scope="scope">
                {{ scope.row.summary }}
            </template>
        </el-table-column>
        <el-table-column prop="drawdownAmount" label="動撥金額" class-name="strong" align="right" width="120">
            <template slot-scope="scope">
                <Money v-if="scope.row.drawdownAmount" :v="scope.row.drawdownAmount" />
            </template>
        </el-table-column>
        <el-table-column prop="repaymentAmount" label="還款金額" class-name="strong" align="right" width="120">
            <template slot-scope="scope">
                <Money v-if="scope.row.repaymentAmount" :v="scope.row.repaymentAmount" />
            </template>
        </el-table-column>
        <el-table-column label="帳務日期" width="120">
            <template slot-scope="scope">
                <div v-if="scope.row.drawdownAmount">{{ scope.row.drawdownDate | dateFormater("YYYY-MM-dd") }}</div>
                <div v-else>{{ scope.row.repaymentDate | dateFormater("YYYY-MM-dd") }}</div>
            </template>
        </el-table-column>
        <el-table-column prop="drawdownAmount" label="借款存入" class-name="blue strong" align="right" width="120">
            <template slot-scope="scope">
                <Money v-if="scope.row.drawdownAmount" :v="scope.row.drawdownAmount" />
            </template>
        </el-table-column>
        <el-table-column prop="bnK_NAM" label="存入帳戶" class-name="blue" align="right" width="120">
            <template slot-scope="scope">
                <span v-if="scope.row.drawdownAmount">{{ scope.row.bnK_NAM }}</span>
            </template>
        </el-table-column>
        <el-table-column prop="principalAmount" label="還款本金" class-name="green" align="right strong" width="120">
            <template slot-scope="scope">
                <Money :v="scope.row.principalAmount" />
            </template>
        </el-table-column>
        <el-table-column prop="interestAmount" label="還款利息" class-name="green" align="right strong" width="120">
            <template slot-scope="scope">
                <Money :v="scope.row.interestAmount" />
            </template>
        </el-table-column>
        <el-table-column prop="bnK_NAM" label="扣款帳戶" class-name="green" align="right" width="120">
            <template slot-scope="scope">
                <span v-if="scope.row.repaymentAmount">{{ scope.row.bnK_NAM }}</span>
            </template>
        </el-table-column>
        <el-table-column prop="feE_CD_AMT" label="信保費" class-name="yellow strong" min-width="100" align="right">
            <template slot-scope="scope">
                <Money v-if="scope.row.drawdownAmount" :v="scope.row.feE_CD_AMT" />
            </template>
        </el-table-column>
        <el-table-column prop="feE_HAND_AMT" label="手續費" class-name="yellow strong" min-width="100" align="right">
            <template slot-scope="scope">
                <Money v-if="scope.row.drawdownAmount" :v="scope.row.feE_HAND_AMT" />
            </template>
        </el-table-column>
        <el-table-column prop="reM_FEE_AMT" label="匯費" class-name="yellow strong" min-width="100" align="right">
            <template slot-scope="scope">
                <Money v-if="scope.row.drawdownAmount" :v="scope.row.reM_FEE_AMT" />
            </template>
        </el-table-column>
        <el-table-column label="建立日期" width="120">
            <template slot-scope="scope">
                <span>{{ scope.row.crT_DAT | dateFormater("YYYY-MM-dd") }}</span>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
import _ from 'lodash';
import AccountingStatusLabel from '@/components/dashboard/Accounting/AccountingSummary/ui/AccountingStatusLabel.vue';
import { PAY_WAY_LIST } from '@/assets/commonData/options';
import AccountingTableMixins from '../AccountingTableMixins.vue';

export default {
    mixins: [AccountingTableMixins],
    props: {
        status: {
            type: String,
            default: '',
        },
        datas: {
            type: Array,
            default: () => [],
        },
    },
    components: { AccountingStatusLabel },
    methods: {
        onRowClick(data) {
            this.$emit('openDetail', { repaymentSno: data.repaymentSno, drawdownSno: data.drawdownSno }, data.vocherStatus);
        },
        getPayWayText(val) {
            return _.find(PAY_WAY_LIST, ['value', val])?.label || '--';
        },
    },
};
</script>

<style lang="scss">
.accounting-summary-payment-table {
    .el-table__body-wrapper {
        height: 550px;
    }
    .blue {
        background-color: #f1f4ff;
    }
    .yellow {
        background-color: #fffde7;
    }
    .green {
        background-color: #f1ffe6;
    }

    .el-table__row {
        cursor: pointer;
    }
}
</style>
